import TableControls from './TableControls';

export default TableControls;



// WEBPACK FOOTER //
// ./src/app/components/TableControls/index.js